import { FC, useEffect } from "react";
import { CircularProgress, IconButton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CloseFullscreen, OpenFullscreen } from "../../../../assets/icons";

interface Props {
	isLoading?: boolean;
	isFullscreen: boolean;
	toggleFullscreen: () => void;
	children: React.ReactNode;
}

export const FullscreenMapWrapper: FC<Props> = ({ isLoading, isFullscreen, toggleFullscreen, children }) => {
	const { t } = useTranslation("common");

	useEffect(() => {
		if (isFullscreen) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "auto";
		}

		return () => {
			document.body.style.overflow = "auto";
		};
	}, [isFullscreen]);

	const fullscreenIcon = isFullscreen ? (
		<CloseFullscreen color="secondary" fontSize="small" />
	) : (
		<OpenFullscreen color="secondary" fontSize="small" />
	);

	return (
		<Stack
			sx={{
				position: isFullscreen ? "fixed" : "relative",
				top: isFullscreen ? 0 : "auto",
				left: isFullscreen ? 0 : "auto",
				width: isFullscreen ? "100vw" : "100%",
				height: isFullscreen ? "100vh" : "100%",
				bgcolor: isFullscreen ? "#00000060" : "transparent",
				zIndex: isFullscreen ? 1300 : "auto",
				padding: isFullscreen ? "40px" : 0,
			}}
		>
			{isLoading && (
				<Stack
					position="absolute"
					display="flex"
					alignItems="center"
					justifyContent="center"
					bgcolor="rgba(255,255,255,0.55)"
					zIndex={500}
					top={isFullscreen ? "40px" : 0}
					left={isFullscreen ? "40px" : 0}
					right={isFullscreen ? "40px" : 0}
					textAlign={"center"}
					padding={1.5}
					flexDirection={"row"}
					alignContent={"center"}
				>
					<CircularProgress size={24} />
					<Typography ml={1} fontWeight={"700"} color="info" variant="body2" textTransform={"uppercase"}>
						{t("loading data")}
					</Typography>
				</Stack>
			)}
			<IconButton
				onClick={toggleFullscreen}
				sx={{
					position: "absolute",
					top: isFullscreen ? "48px" : 4,
					right: isFullscreen ? "48px" : 4,
					bgcolor: "white",
					boxShadow: 2,
					zIndex: 1000,
					width: 32,
					height: 32,
				}}
			>
				{fullscreenIcon}
			</IconButton>
			{children}
		</Stack>
	);
};
